<script>
import Mixin from "./Mixin";
import route from "ziggy-js";
    export default {
        mixins: [Mixin],
        methods: {
            printClick() {
                let divToPrint=document.getElementById('report');
                let newWin=window.open('','Print-Window');
                newWin.document.open();
                newWin.document.write('<html><body onload="window.print()">'+divToPrint.innerHTML+'</body></html>');
                newWin.document.close();
                setTimeout(function(){newWin.close();},10);
            },
            exportRequest(analyticId, params) {
                if (analyticId) {
                    let url = new URL(route('analytics.export', analyticId));
                    for (const [key, value] of Object.entries(params)) {
                        url.searchParams.set(key, value);
                    }

                    window.location.href = url;
                }
            },
        }
    }
</script>
